module.exports = __webpack_public_path__ + "assets/img/img269.f4b57ad6.png";